<script lang="ts">
  import Bank from "~icons/ph/bank";
  import Circle from "~icons/ph/circle-thin";
  import CircleNotch from "~icons/ph/circle-notch-thin";

  let {
    title,
    description,
  }: {
    title: string;
    description: string;
  } = $props();

  let circleIconSize = "h-[160px] w-[160px]";
</script>

<div class="bg-gradient-to-b from-sky-200/40 -m-4 px-4 py-24 flex flex-col items-center justify-center h-full gap-3">
  <div class="shrink-0 pb-3">
    <div class="grid {circleIconSize} place-items-center">
      <Circle class="col-start-1 row-start-1 text-gray-200 {circleIconSize}" />
      <CircleNotch class="col-start-1 row-start-1 text-emerald-500 {circleIconSize} animate-spin" />
      <div
        class="col-start-1 row-start-1 z-10 flex h-[85px] w-[85px] items-center justify-center rounded-full bg-white shadow">
        <Bank class="text-gray-400 h-[60px] w-[60px]" />
      </div>
    </div>
  </div>

  <h3 class="text-xl">{title}</h3>
  <p class="text-gray-500 text-center">{description}</p>
</div>
